// Zkrácený text (complaints/_expandable_text) — odkaz rozbalí / sbalí celý text
$(document).on("click", ".expandable-toggle", function (e) {
  e.preventDefault();
  var $box = $(this).closest(".expandable-text");
  var expanded = $box.find(".expandable-full").is(":visible");
  $box.find(".expandable-full").toggle(!expanded);
  $box.find(".expandable-short").toggle(expanded);
  $(this).text(expanded ? $(this).data("more") : $(this).data("less"));
});
